import store from '@/store';
import S_base from '@/__vue2stone/service/wasaapi/v1/__base';

export default {
  async indexField(params) {
    const _params = {
      factory: store.state.app.factory.id,
      order_by: 'sequence',
      order_way: 'asc',
      ...params,
    };
    const res = S_base.index({
      modelName: 'meeting_template_field',
      params: _params,
    });
    return res;
  },
  async indexType(params) {
    const _params = {
      factory: store.state.app.factory.id,
      ...params,
    };
    const res = S_base.index({
      modelName: 'meeting_template_type',
      params: _params,
    });
    return res;
  },
  async create(data) {
    const factoryId = store.state.app.factory.id;
    const _data = {
      factory: factoryId,
      ...data,
    };
    const res = await S_base.create({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'meeting_template',
      data: _data,
    });
    return res;
  },
  async show(templateId) {
    const params = {
      factory: store.state.app.factory.id,
    };
    const res = await S_base.show({
      modelName: 'meeting_template',
      modelId: templateId,
      params,
    });
    return res;
  },
  async update(templateId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await S_base.update({
      modelName: 'meeting_template',
      modelId: templateId,
      data: _data,
    });
    return res;
  },
  async index(params) {
    const res = S_base.index({
      parentName: 'factory',
      parentId: store.state.app.factory.id,
      modelName: 'meeting_template',
      params,
    });
    return res;
  },
  async indexTemplateItems(templateId, params) {
    const _params = {
      factory: store.state.app.factory.id,
      ...params,
    };
    const res = S_base.index({
      parentName: 'meeting_template',
      parentId: templateId,
      modelName: 'meeting_template_item',
      params: _params,
    });
    return res;
  },
  async delete(templateId) {
    const params = {
      factory: store.state.app.factory.id,
    };
    const res = await S_base.delete({
      modelName: 'meeting_template',
      modelId: templateId,
      params,
    });
    return res;
  },
}
